/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { ForwardRef } from '../types'
import { darken } from 'polished'
import { theme } from '../gatsby-plugin-theme-ui/theme'

export const ButtonBlock: ForwardRef<
  HTMLButtonElement,
  React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>
> = React.forwardRef((props, ref) => (
  <button
    ref={ref}
    sx={{
      padding: 0,
      fontSize: 2,
      fontFamily: 'body',
      backgroundColor: 'initial',
      color: theme.colors.text,
      textDecoration: 'none',
      textAlign: 'left',
      display: 'block',
      width: '100%',
      appearance: 'none',
      boxShadow: 'none',
      border: 'none',
      cursor: 'pointer',
      ':focus, :hover': {
        outline: 'none',
        textDecoration: 'none',
        // boxShadow: '0 0px 10px 0 rgba(0, 0, 0, 0.1)',
        // backgroundColor: darken(0.1)(theme.colors.text),
      },
    }}
    {...props}
  />
))
